import React from 'react'
import styles from './Backdrop.module.css'

const Backdrop: React.FC<{onClick: () => void}> = props => {
    return (
        <div className={styles.Backdrop} onClick={props.onClick}/>
    )
}

export default Backdrop